import React from 'react';
import DaumPostcode from 'react-daum-postcode';
import '../css_admin/Post.css';
// Modal import
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';

// Kakao Local
const key = require('../config/key');

// Modal const
const poststyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    borderRadius: '16px',
    border: 'none',
    boxShadow: 14,
    p: 4
};

const Post = (props) => {
    const complete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? `(${extraAddress})` : '');
        }
        console.log(data);
        console.log(fullAddress);
        console.log(data.zonecode);

        let kakaoAK = 'KakaoAK ' + key.KAKAO_APP_KEY;
        axios.get(`https://dapi.kakao.com/v2/local/search/address.json?query=${fullAddress}`, {
            headers: { Authorization: kakaoAK }
        }).then(res => {
            const location = res.data.documents[0];
            console.log('si', location.address.region_1depth_name);
            console.log('gu', location.address.region_2depth_name);
            console.log('dong', location.address.region_3depth_name);
            console.log('latitude', location.address.y);
            console.log('longtitude', location.address.x);

            props.setaddress({
                ...props.address,
                address: fullAddress,
                postal: data.zonecode,
                latitude: location.address.y,
                longitude: location.address.x
            })
    
            props.onClose();
        });
    };

    return (
        <div>
            <Box sx={poststyle}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    주소
                </Typography>
                <Typography className="modalCloseIcon" sx={{ mt: -3.5 }} component="div">
                    <CloseIcon onClick={props.onClose} />
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 3 }} component="div">
                    <DaumPostcode
                        className=''
                        autoClose
                        onComplete={complete} />
                </Typography>
            </Box>
        </div>
    );
};

export default Post;
